import { animate, animateChild, group, query, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CampaignService } from '@services/campaign.service';

@Component({
  selector: 'wsb-select-email-campaign-modal',
  templateUrl: './select-email-campaign-modal.component.html',
  styleUrls: ['./select-email-campaign-modal.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('200ms 350ms', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('100ms', style({ opacity: 0 }))])
    ]),
    trigger('modalWidth', [
      state('small', style({ width: '400px' })),
      state('large', style({ width: '800px' })),
      transition('small => large', [
        group([query('@enterAnimation', animateChild()), animate('500ms ease-out', style({ width: '800px' }))])
      ]),
      transition('large => small', group([query('@enterAnimation', animateChild()), animate('500ms ease-out', style({ width: '400px' }))]))
    ])
  ],
  standalone: false
})
export class SelectEmailCampaignModalComponent implements OnInit {
  @Input() unsubscribe;
  emailCampaignList: Array<any>;
  modalState = 'small';

  constructor(private campaignService: CampaignService, public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.getEmailCampaignList();
  }

  getEmailCampaignList() {
    this.campaignService.getCampaignsListsByStatus('ACTIVE').subscribe(x => {
      this.emailCampaignList = x.map(y => {
        (y as any).selected = false;
        (y as any).optin = false;
        return y;
      });
    });
  }

  setEmailServiceStatus(event) {
    if (this.unsubscribe && event) {
    } else if (this.unsubscribe && !event) {
      const checkSelected = this.emailCampaignList.find(campaign => campaign.selected);
      if (!checkSelected) {
      }
    } else if (event) {
      this.modalState = 'large';
    } else {
      const checkSelected = this.emailCampaignList.find(campaign => campaign.selected);
      if (!checkSelected) {
        this.modalState = 'small';
      }
    }
  }

  getData() {
    const campaigns = this.emailCampaignList
      .filter(x => x.selected)
      .map(x => {
        return { idCampaign: x.idCampaign as string, optin: x.optin };
      });
    return {
      campaigns,
      emailServiceStatus: this.unsubscribe ? false : true,
      smsServiceStatus: false,
      unsubscribe: this.unsubscribe ? true : false
    };
  }
}
